import PageWrapper from "../components/common/PageWrapper";
import Header from "../components/common/Header";
import BodyWrapper from "../components/common/BodyWrapper";
import Footer from "../components/common/Footer";
import ScrollToTop from "../components/common/ScrollToTop";
import TopStepsStatus from "../components/planPartials/TopStepsStatus";
import { useGeneral } from "../components/contexts/GeneralContext";
import { useStep } from "../components/contexts/SubscriptionContext";
import { useEffect } from "react";
import DateCustomization from "../components/planPartials/DateCustomization";

const SubscribeDateSelection = () => {
  const { discountCoupons } = useGeneral();
  const { goToStep } = useStep();
  useEffect(() => {
    goToStep("3.2");
  }, []);
  return (
    <>
      <ScrollToTop />
      <PageWrapper loading={false} className="">
        <Header code={discountCoupons} />
       
        <BodyWrapper className="">
          <TopStepsStatus rightText={""} url={""} />
          <div className="pt-4 lg:pt-9">
            <DateCustomization
            />
          </div>
        </BodyWrapper>
        <Footer />
      </PageWrapper>
    </>
  );
};

export default SubscribeDateSelection;
